
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("2SxEv"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("dsFNj"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("iOAKO"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("57hTZ"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("5k0Aa"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("hZHDB"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("7Azv1"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("gqEG2"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("2pzpp"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("fbt1w"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("5CTj8"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("1fgXx"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("2SxEv", function(module, exports) {

let $218aba94a2bd4559$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $218aba94a2bd4559$var$load("2YffH"),
    $218aba94a2bd4559$var$load("1o23t"),
    $218aba94a2bd4559$var$load("lqFMg"),
    $218aba94a2bd4559$var$load("1aRD3"),
    $218aba94a2bd4559$var$load("87LvA"),
    $218aba94a2bd4559$var$load("l1nJ9"),
    $218aba94a2bd4559$var$load("iQ0Jm"),
    $218aba94a2bd4559$var$load("eBRUf"),
    $218aba94a2bd4559$var$load("9Vh0G"),
    $218aba94a2bd4559$var$load("hBIgN"),
    $218aba94a2bd4559$var$load("h4Nf7"),
    $218aba94a2bd4559$var$load("7f9Fz"),
    $218aba94a2bd4559$var$load("8YSo7"),
    $218aba94a2bd4559$var$load("cANzj"),
    $218aba94a2bd4559$var$load("57vQM"),
    $218aba94a2bd4559$var$load("g9CVe"),
    $218aba94a2bd4559$var$load("djHM5"),
    $218aba94a2bd4559$var$load("eJQji"),
    $218aba94a2bd4559$var$load("6wr18"),
    $218aba94a2bd4559$var$load("kjZZD"),
    $218aba94a2bd4559$var$load("3JSgG"),
    $218aba94a2bd4559$var$load("dRpV3"),
    $218aba94a2bd4559$var$load("ffEVr"),
    $218aba94a2bd4559$var$load("28arV"),
    $218aba94a2bd4559$var$load("jYUNl"),
    $218aba94a2bd4559$var$load("foy8I"),
    $218aba94a2bd4559$var$load("jY21r"),
    $218aba94a2bd4559$var$load("2vAWg"),
    $218aba94a2bd4559$var$load("7cABH"),
    $218aba94a2bd4559$var$load("9jjvO"),
    $218aba94a2bd4559$var$load("i8eeg"),
    $218aba94a2bd4559$var$load("iFdoJ"),
    $218aba94a2bd4559$var$load("2uVTT"),
    $218aba94a2bd4559$var$load("hhss7"),
    $218aba94a2bd4559$var$load("Wowvf"),
    $218aba94a2bd4559$var$load("4Nzvy"),
    $218aba94a2bd4559$var$load("hJpvQ"),
    $218aba94a2bd4559$var$load("bIPPg"),
    $218aba94a2bd4559$var$load("lnKog"),
    $218aba94a2bd4559$var$load("h3ABO"),
    $218aba94a2bd4559$var$load("kC80R"),
    $218aba94a2bd4559$var$load("7EorR"),
    $218aba94a2bd4559$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("dsFNj", function(module, exports) {

let $9cce4f5a0c819cf4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9cce4f5a0c819cf4$var$load("2YffH"),
    $9cce4f5a0c819cf4$var$load("1o23t"),
    $9cce4f5a0c819cf4$var$load("lqFMg"),
    $9cce4f5a0c819cf4$var$load("1aRD3"),
    $9cce4f5a0c819cf4$var$load("87LvA"),
    $9cce4f5a0c819cf4$var$load("l1nJ9"),
    $9cce4f5a0c819cf4$var$load("iQ0Jm"),
    $9cce4f5a0c819cf4$var$load("eBRUf"),
    $9cce4f5a0c819cf4$var$load("9Vh0G"),
    $9cce4f5a0c819cf4$var$load("hBIgN"),
    $9cce4f5a0c819cf4$var$load("h4Nf7"),
    $9cce4f5a0c819cf4$var$load("7f9Fz"),
    $9cce4f5a0c819cf4$var$load("8YSo7"),
    $9cce4f5a0c819cf4$var$load("cANzj"),
    $9cce4f5a0c819cf4$var$load("57vQM"),
    $9cce4f5a0c819cf4$var$load("g9CVe"),
    $9cce4f5a0c819cf4$var$load("djHM5"),
    $9cce4f5a0c819cf4$var$load("eJQji"),
    $9cce4f5a0c819cf4$var$load("6wr18"),
    $9cce4f5a0c819cf4$var$load("kjZZD"),
    $9cce4f5a0c819cf4$var$load("3JSgG"),
    $9cce4f5a0c819cf4$var$load("dRpV3"),
    $9cce4f5a0c819cf4$var$load("ffEVr"),
    $9cce4f5a0c819cf4$var$load("28arV"),
    $9cce4f5a0c819cf4$var$load("jYUNl"),
    $9cce4f5a0c819cf4$var$load("foy8I"),
    $9cce4f5a0c819cf4$var$load("jY21r"),
    $9cce4f5a0c819cf4$var$load("2vAWg"),
    $9cce4f5a0c819cf4$var$load("7cABH"),
    $9cce4f5a0c819cf4$var$load("9jjvO"),
    $9cce4f5a0c819cf4$var$load("i8eeg"),
    $9cce4f5a0c819cf4$var$load("iFdoJ"),
    $9cce4f5a0c819cf4$var$load("2uVTT"),
    $9cce4f5a0c819cf4$var$load("hhss7"),
    $9cce4f5a0c819cf4$var$load("Wowvf"),
    $9cce4f5a0c819cf4$var$load("4Nzvy"),
    $9cce4f5a0c819cf4$var$load("hJpvQ"),
    $9cce4f5a0c819cf4$var$load("bIPPg"),
    $9cce4f5a0c819cf4$var$load("lnKog"),
    $9cce4f5a0c819cf4$var$load("h3ABO"),
    $9cce4f5a0c819cf4$var$load("kC80R"),
    $9cce4f5a0c819cf4$var$load("7EorR"),
    $9cce4f5a0c819cf4$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("iOAKO", function(module, exports) {

let $db29681ab4eb49cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $db29681ab4eb49cb$var$load("2YffH"),
    $db29681ab4eb49cb$var$load("1o23t"),
    $db29681ab4eb49cb$var$load("lqFMg"),
    $db29681ab4eb49cb$var$load("1aRD3"),
    $db29681ab4eb49cb$var$load("87LvA"),
    $db29681ab4eb49cb$var$load("l1nJ9"),
    $db29681ab4eb49cb$var$load("iQ0Jm"),
    $db29681ab4eb49cb$var$load("eBRUf"),
    $db29681ab4eb49cb$var$load("9Vh0G"),
    $db29681ab4eb49cb$var$load("hBIgN"),
    $db29681ab4eb49cb$var$load("h4Nf7"),
    $db29681ab4eb49cb$var$load("7f9Fz"),
    $db29681ab4eb49cb$var$load("8YSo7"),
    $db29681ab4eb49cb$var$load("cANzj"),
    $db29681ab4eb49cb$var$load("57vQM"),
    $db29681ab4eb49cb$var$load("g9CVe"),
    $db29681ab4eb49cb$var$load("djHM5"),
    $db29681ab4eb49cb$var$load("eJQji"),
    $db29681ab4eb49cb$var$load("6wr18"),
    $db29681ab4eb49cb$var$load("kjZZD"),
    $db29681ab4eb49cb$var$load("3JSgG"),
    $db29681ab4eb49cb$var$load("dRpV3"),
    $db29681ab4eb49cb$var$load("ffEVr"),
    $db29681ab4eb49cb$var$load("28arV"),
    $db29681ab4eb49cb$var$load("jYUNl"),
    $db29681ab4eb49cb$var$load("foy8I"),
    $db29681ab4eb49cb$var$load("jY21r"),
    $db29681ab4eb49cb$var$load("2vAWg"),
    $db29681ab4eb49cb$var$load("7cABH"),
    $db29681ab4eb49cb$var$load("9jjvO"),
    $db29681ab4eb49cb$var$load("i8eeg"),
    $db29681ab4eb49cb$var$load("iFdoJ"),
    $db29681ab4eb49cb$var$load("2uVTT"),
    $db29681ab4eb49cb$var$load("hhss7"),
    $db29681ab4eb49cb$var$load("Wowvf"),
    $db29681ab4eb49cb$var$load("4Nzvy"),
    $db29681ab4eb49cb$var$load("hJpvQ"),
    $db29681ab4eb49cb$var$load("bIPPg"),
    $db29681ab4eb49cb$var$load("lnKog"),
    $db29681ab4eb49cb$var$load("h3ABO"),
    $db29681ab4eb49cb$var$load("kC80R"),
    $db29681ab4eb49cb$var$load("7EorR"),
    $db29681ab4eb49cb$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("57hTZ", function(module, exports) {

let $3b9b7e2a8807a62b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3b9b7e2a8807a62b$var$load("cANzj"),
    $3b9b7e2a8807a62b$var$load("57vQM"),
    $3b9b7e2a8807a62b$var$load("2YffH"),
    $3b9b7e2a8807a62b$var$load("lqFMg"),
    $3b9b7e2a8807a62b$var$load("1aRD3"),
    $3b9b7e2a8807a62b$var$load("87LvA"),
    $3b9b7e2a8807a62b$var$load("hJpvQ"),
    $3b9b7e2a8807a62b$var$load("l1nJ9"),
    $3b9b7e2a8807a62b$var$load("eBRUf"),
    $3b9b7e2a8807a62b$var$load("9Vh0G"),
    $3b9b7e2a8807a62b$var$load("hBIgN"),
    $3b9b7e2a8807a62b$var$load("h4Nf7"),
    $3b9b7e2a8807a62b$var$load("7f9Fz"),
    $3b9b7e2a8807a62b$var$load("8YSo7"),
    $3b9b7e2a8807a62b$var$load("g9CVe"),
    $3b9b7e2a8807a62b$var$load("djHM5"),
    $3b9b7e2a8807a62b$var$load("eJQji"),
    $3b9b7e2a8807a62b$var$load("6wr18"),
    $3b9b7e2a8807a62b$var$load("kjZZD"),
    $3b9b7e2a8807a62b$var$load("3JSgG"),
    $3b9b7e2a8807a62b$var$load("dRpV3"),
    $3b9b7e2a8807a62b$var$load("ffEVr"),
    $3b9b7e2a8807a62b$var$load("28arV"),
    $3b9b7e2a8807a62b$var$load("jYUNl"),
    $3b9b7e2a8807a62b$var$load("foy8I"),
    $3b9b7e2a8807a62b$var$load("jY21r"),
    $3b9b7e2a8807a62b$var$load("2vAWg"),
    $3b9b7e2a8807a62b$var$load("7cABH"),
    $3b9b7e2a8807a62b$var$load("9jjvO"),
    $3b9b7e2a8807a62b$var$load("i8eeg"),
    $3b9b7e2a8807a62b$var$load("iFdoJ"),
    $3b9b7e2a8807a62b$var$load("bIPPg"),
    $3b9b7e2a8807a62b$var$load("2uVTT"),
    $3b9b7e2a8807a62b$var$load("hhss7"),
    $3b9b7e2a8807a62b$var$load("Wowvf"),
    $3b9b7e2a8807a62b$var$load("4Nzvy"),
    $3b9b7e2a8807a62b$var$load("h3ABO"),
    $3b9b7e2a8807a62b$var$load("kC80R"),
    $3b9b7e2a8807a62b$var$load("7EorR"),
    $3b9b7e2a8807a62b$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("5k0Aa", function(module, exports) {

let $3dff45ac139c407c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3dff45ac139c407c$var$load("cANzj"),
    $3dff45ac139c407c$var$load("57vQM"),
    $3dff45ac139c407c$var$load("2YffH"),
    $3dff45ac139c407c$var$load("lqFMg"),
    $3dff45ac139c407c$var$load("1aRD3"),
    $3dff45ac139c407c$var$load("87LvA"),
    $3dff45ac139c407c$var$load("hJpvQ"),
    $3dff45ac139c407c$var$load("l1nJ9"),
    $3dff45ac139c407c$var$load("eBRUf"),
    $3dff45ac139c407c$var$load("9Vh0G"),
    $3dff45ac139c407c$var$load("hBIgN"),
    $3dff45ac139c407c$var$load("h4Nf7"),
    $3dff45ac139c407c$var$load("7f9Fz"),
    $3dff45ac139c407c$var$load("8YSo7"),
    $3dff45ac139c407c$var$load("g9CVe"),
    $3dff45ac139c407c$var$load("djHM5"),
    $3dff45ac139c407c$var$load("eJQji"),
    $3dff45ac139c407c$var$load("6wr18"),
    $3dff45ac139c407c$var$load("kjZZD"),
    $3dff45ac139c407c$var$load("3JSgG"),
    $3dff45ac139c407c$var$load("dRpV3"),
    $3dff45ac139c407c$var$load("ffEVr"),
    $3dff45ac139c407c$var$load("28arV"),
    $3dff45ac139c407c$var$load("jYUNl"),
    $3dff45ac139c407c$var$load("foy8I"),
    $3dff45ac139c407c$var$load("jY21r"),
    $3dff45ac139c407c$var$load("2vAWg"),
    $3dff45ac139c407c$var$load("7cABH"),
    $3dff45ac139c407c$var$load("9jjvO"),
    $3dff45ac139c407c$var$load("i8eeg"),
    $3dff45ac139c407c$var$load("iFdoJ"),
    $3dff45ac139c407c$var$load("bIPPg"),
    $3dff45ac139c407c$var$load("2uVTT"),
    $3dff45ac139c407c$var$load("hhss7"),
    $3dff45ac139c407c$var$load("Wowvf"),
    $3dff45ac139c407c$var$load("4Nzvy"),
    $3dff45ac139c407c$var$load("h3ABO"),
    $3dff45ac139c407c$var$load("kC80R"),
    $3dff45ac139c407c$var$load("7EorR"),
    $3dff45ac139c407c$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("hZHDB", function(module, exports) {

let $d199fbbd0d2858bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d199fbbd0d2858bb$var$load("cANzj"),
    $d199fbbd0d2858bb$var$load("57vQM"),
    $d199fbbd0d2858bb$var$load("2YffH"),
    $d199fbbd0d2858bb$var$load("lqFMg"),
    $d199fbbd0d2858bb$var$load("1aRD3"),
    $d199fbbd0d2858bb$var$load("87LvA"),
    $d199fbbd0d2858bb$var$load("hJpvQ"),
    $d199fbbd0d2858bb$var$load("l1nJ9"),
    $d199fbbd0d2858bb$var$load("eBRUf"),
    $d199fbbd0d2858bb$var$load("9Vh0G"),
    $d199fbbd0d2858bb$var$load("hBIgN"),
    $d199fbbd0d2858bb$var$load("h4Nf7"),
    $d199fbbd0d2858bb$var$load("7f9Fz"),
    $d199fbbd0d2858bb$var$load("8YSo7"),
    $d199fbbd0d2858bb$var$load("g9CVe"),
    $d199fbbd0d2858bb$var$load("djHM5"),
    $d199fbbd0d2858bb$var$load("eJQji"),
    $d199fbbd0d2858bb$var$load("6wr18"),
    $d199fbbd0d2858bb$var$load("kjZZD"),
    $d199fbbd0d2858bb$var$load("3JSgG"),
    $d199fbbd0d2858bb$var$load("dRpV3"),
    $d199fbbd0d2858bb$var$load("ffEVr"),
    $d199fbbd0d2858bb$var$load("28arV"),
    $d199fbbd0d2858bb$var$load("jYUNl"),
    $d199fbbd0d2858bb$var$load("foy8I"),
    $d199fbbd0d2858bb$var$load("jY21r"),
    $d199fbbd0d2858bb$var$load("2vAWg"),
    $d199fbbd0d2858bb$var$load("7cABH"),
    $d199fbbd0d2858bb$var$load("9jjvO"),
    $d199fbbd0d2858bb$var$load("i8eeg"),
    $d199fbbd0d2858bb$var$load("iFdoJ"),
    $d199fbbd0d2858bb$var$load("bIPPg"),
    $d199fbbd0d2858bb$var$load("2uVTT"),
    $d199fbbd0d2858bb$var$load("hhss7"),
    $d199fbbd0d2858bb$var$load("Wowvf"),
    $d199fbbd0d2858bb$var$load("4Nzvy"),
    $d199fbbd0d2858bb$var$load("h3ABO"),
    $d199fbbd0d2858bb$var$load("kC80R"),
    $d199fbbd0d2858bb$var$load("7EorR"),
    $d199fbbd0d2858bb$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("7Azv1", function(module, exports) {

let $58676e9acc3056c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $58676e9acc3056c8$var$load("cANzj"),
    $58676e9acc3056c8$var$load("57vQM"),
    $58676e9acc3056c8$var$load("2YffH"),
    $58676e9acc3056c8$var$load("lqFMg"),
    $58676e9acc3056c8$var$load("1aRD3"),
    $58676e9acc3056c8$var$load("87LvA"),
    $58676e9acc3056c8$var$load("l1nJ9"),
    $58676e9acc3056c8$var$load("eBRUf"),
    $58676e9acc3056c8$var$load("9Vh0G"),
    $58676e9acc3056c8$var$load("hBIgN"),
    $58676e9acc3056c8$var$load("h4Nf7"),
    $58676e9acc3056c8$var$load("7f9Fz"),
    $58676e9acc3056c8$var$load("8YSo7"),
    $58676e9acc3056c8$var$load("g9CVe"),
    $58676e9acc3056c8$var$load("djHM5"),
    $58676e9acc3056c8$var$load("eJQji"),
    $58676e9acc3056c8$var$load("6wr18"),
    $58676e9acc3056c8$var$load("kjZZD"),
    $58676e9acc3056c8$var$load("3JSgG"),
    $58676e9acc3056c8$var$load("dRpV3"),
    $58676e9acc3056c8$var$load("ffEVr"),
    $58676e9acc3056c8$var$load("28arV"),
    $58676e9acc3056c8$var$load("jYUNl"),
    $58676e9acc3056c8$var$load("foy8I"),
    $58676e9acc3056c8$var$load("jY21r"),
    $58676e9acc3056c8$var$load("2vAWg"),
    $58676e9acc3056c8$var$load("7cABH"),
    $58676e9acc3056c8$var$load("9jjvO"),
    $58676e9acc3056c8$var$load("i8eeg"),
    $58676e9acc3056c8$var$load("iFdoJ"),
    $58676e9acc3056c8$var$load("2uVTT"),
    $58676e9acc3056c8$var$load("hhss7"),
    $58676e9acc3056c8$var$load("Wowvf"),
    $58676e9acc3056c8$var$load("4Nzvy"),
    $58676e9acc3056c8$var$load("hJpvQ"),
    $58676e9acc3056c8$var$load("bIPPg"),
    $58676e9acc3056c8$var$load("lnKog"),
    $58676e9acc3056c8$var$load("h3ABO"),
    $58676e9acc3056c8$var$load("kC80R"),
    $58676e9acc3056c8$var$load("7EorR"),
    $58676e9acc3056c8$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("gqEG2", function(module, exports) {

let $bf5ea0a42999ee94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf5ea0a42999ee94$var$load("2YffH"),
    $bf5ea0a42999ee94$var$load("lqFMg"),
    $bf5ea0a42999ee94$var$load("1aRD3"),
    $bf5ea0a42999ee94$var$load("87LvA"),
    $bf5ea0a42999ee94$var$load("l1nJ9"),
    $bf5ea0a42999ee94$var$load("eBRUf"),
    $bf5ea0a42999ee94$var$load("9Vh0G"),
    $bf5ea0a42999ee94$var$load("hBIgN"),
    $bf5ea0a42999ee94$var$load("h4Nf7"),
    $bf5ea0a42999ee94$var$load("7f9Fz"),
    $bf5ea0a42999ee94$var$load("8YSo7"),
    $bf5ea0a42999ee94$var$load("cANzj"),
    $bf5ea0a42999ee94$var$load("57vQM"),
    $bf5ea0a42999ee94$var$load("g9CVe"),
    $bf5ea0a42999ee94$var$load("djHM5"),
    $bf5ea0a42999ee94$var$load("eJQji"),
    $bf5ea0a42999ee94$var$load("6wr18"),
    $bf5ea0a42999ee94$var$load("kjZZD"),
    $bf5ea0a42999ee94$var$load("3JSgG"),
    $bf5ea0a42999ee94$var$load("dRpV3"),
    $bf5ea0a42999ee94$var$load("ffEVr"),
    $bf5ea0a42999ee94$var$load("28arV"),
    $bf5ea0a42999ee94$var$load("jYUNl"),
    $bf5ea0a42999ee94$var$load("foy8I"),
    $bf5ea0a42999ee94$var$load("jY21r"),
    $bf5ea0a42999ee94$var$load("2vAWg"),
    $bf5ea0a42999ee94$var$load("7cABH"),
    $bf5ea0a42999ee94$var$load("9jjvO"),
    $bf5ea0a42999ee94$var$load("i8eeg"),
    $bf5ea0a42999ee94$var$load("iFdoJ"),
    $bf5ea0a42999ee94$var$load("2uVTT"),
    $bf5ea0a42999ee94$var$load("hhss7"),
    $bf5ea0a42999ee94$var$load("Wowvf"),
    $bf5ea0a42999ee94$var$load("4Nzvy"),
    $bf5ea0a42999ee94$var$load("hJpvQ"),
    $bf5ea0a42999ee94$var$load("bIPPg"),
    $bf5ea0a42999ee94$var$load("lnKog"),
    $bf5ea0a42999ee94$var$load("h3ABO"),
    $bf5ea0a42999ee94$var$load("kC80R"),
    $bf5ea0a42999ee94$var$load("7EorR"),
    $bf5ea0a42999ee94$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("2pzpp", function(module, exports) {

let $1c196202834472de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1c196202834472de$var$load("2YffH"),
    $1c196202834472de$var$load("lqFMg"),
    $1c196202834472de$var$load("1aRD3"),
    $1c196202834472de$var$load("87LvA"),
    $1c196202834472de$var$load("l1nJ9"),
    $1c196202834472de$var$load("eBRUf"),
    $1c196202834472de$var$load("9Vh0G"),
    $1c196202834472de$var$load("hBIgN"),
    $1c196202834472de$var$load("h4Nf7"),
    $1c196202834472de$var$load("7f9Fz"),
    $1c196202834472de$var$load("8YSo7"),
    $1c196202834472de$var$load("cANzj"),
    $1c196202834472de$var$load("57vQM"),
    $1c196202834472de$var$load("g9CVe"),
    $1c196202834472de$var$load("djHM5"),
    $1c196202834472de$var$load("eJQji"),
    $1c196202834472de$var$load("6wr18"),
    $1c196202834472de$var$load("kjZZD"),
    $1c196202834472de$var$load("3JSgG"),
    $1c196202834472de$var$load("dRpV3"),
    $1c196202834472de$var$load("ffEVr"),
    $1c196202834472de$var$load("28arV"),
    $1c196202834472de$var$load("jYUNl"),
    $1c196202834472de$var$load("foy8I"),
    $1c196202834472de$var$load("jY21r"),
    $1c196202834472de$var$load("2vAWg"),
    $1c196202834472de$var$load("7cABH"),
    $1c196202834472de$var$load("9jjvO"),
    $1c196202834472de$var$load("i8eeg"),
    $1c196202834472de$var$load("iFdoJ"),
    $1c196202834472de$var$load("2uVTT"),
    $1c196202834472de$var$load("hhss7"),
    $1c196202834472de$var$load("Wowvf"),
    $1c196202834472de$var$load("4Nzvy"),
    $1c196202834472de$var$load("hJpvQ"),
    $1c196202834472de$var$load("bIPPg"),
    $1c196202834472de$var$load("lnKog"),
    $1c196202834472de$var$load("h3ABO"),
    $1c196202834472de$var$load("kC80R"),
    $1c196202834472de$var$load("7EorR"),
    $1c196202834472de$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("fbt1w", function(module, exports) {

let $b0de659013f56349$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0de659013f56349$var$load("cANzj"),
    $b0de659013f56349$var$load("57vQM"),
    $b0de659013f56349$var$load("2YffH"),
    $b0de659013f56349$var$load("lqFMg"),
    $b0de659013f56349$var$load("1aRD3"),
    $b0de659013f56349$var$load("87LvA"),
    $b0de659013f56349$var$load("hJpvQ"),
    $b0de659013f56349$var$load("l1nJ9"),
    $b0de659013f56349$var$load("eBRUf"),
    $b0de659013f56349$var$load("9Vh0G"),
    $b0de659013f56349$var$load("hBIgN"),
    $b0de659013f56349$var$load("h4Nf7"),
    $b0de659013f56349$var$load("7f9Fz"),
    $b0de659013f56349$var$load("8YSo7"),
    $b0de659013f56349$var$load("g9CVe"),
    $b0de659013f56349$var$load("djHM5"),
    $b0de659013f56349$var$load("eJQji"),
    $b0de659013f56349$var$load("6wr18"),
    $b0de659013f56349$var$load("kjZZD"),
    $b0de659013f56349$var$load("3JSgG"),
    $b0de659013f56349$var$load("dRpV3"),
    $b0de659013f56349$var$load("ffEVr"),
    $b0de659013f56349$var$load("28arV"),
    $b0de659013f56349$var$load("jYUNl"),
    $b0de659013f56349$var$load("foy8I"),
    $b0de659013f56349$var$load("jY21r"),
    $b0de659013f56349$var$load("2vAWg"),
    $b0de659013f56349$var$load("7cABH"),
    $b0de659013f56349$var$load("9jjvO"),
    $b0de659013f56349$var$load("i8eeg"),
    $b0de659013f56349$var$load("iFdoJ"),
    $b0de659013f56349$var$load("bIPPg"),
    $b0de659013f56349$var$load("2uVTT"),
    $b0de659013f56349$var$load("hhss7"),
    $b0de659013f56349$var$load("Wowvf"),
    $b0de659013f56349$var$load("4Nzvy"),
    $b0de659013f56349$var$load("h3ABO"),
    $b0de659013f56349$var$load("kC80R"),
    $b0de659013f56349$var$load("7EorR"),
    $b0de659013f56349$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("5CTj8", function(module, exports) {

let $418b674ba8b1e0e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $418b674ba8b1e0e7$var$load("cANzj"),
    $418b674ba8b1e0e7$var$load("57vQM"),
    $418b674ba8b1e0e7$var$load("2YffH"),
    $418b674ba8b1e0e7$var$load("lqFMg"),
    $418b674ba8b1e0e7$var$load("1aRD3"),
    $418b674ba8b1e0e7$var$load("87LvA"),
    $418b674ba8b1e0e7$var$load("l1nJ9"),
    $418b674ba8b1e0e7$var$load("eBRUf"),
    $418b674ba8b1e0e7$var$load("9Vh0G"),
    $418b674ba8b1e0e7$var$load("hBIgN"),
    $418b674ba8b1e0e7$var$load("h4Nf7"),
    $418b674ba8b1e0e7$var$load("7f9Fz"),
    $418b674ba8b1e0e7$var$load("8YSo7"),
    $418b674ba8b1e0e7$var$load("g9CVe"),
    $418b674ba8b1e0e7$var$load("djHM5"),
    $418b674ba8b1e0e7$var$load("eJQji"),
    $418b674ba8b1e0e7$var$load("6wr18"),
    $418b674ba8b1e0e7$var$load("kjZZD"),
    $418b674ba8b1e0e7$var$load("3JSgG"),
    $418b674ba8b1e0e7$var$load("dRpV3"),
    $418b674ba8b1e0e7$var$load("ffEVr"),
    $418b674ba8b1e0e7$var$load("28arV"),
    $418b674ba8b1e0e7$var$load("jYUNl"),
    $418b674ba8b1e0e7$var$load("foy8I"),
    $418b674ba8b1e0e7$var$load("jY21r"),
    $418b674ba8b1e0e7$var$load("2vAWg"),
    $418b674ba8b1e0e7$var$load("7cABH"),
    $418b674ba8b1e0e7$var$load("9jjvO"),
    $418b674ba8b1e0e7$var$load("i8eeg"),
    $418b674ba8b1e0e7$var$load("iFdoJ"),
    $418b674ba8b1e0e7$var$load("2uVTT"),
    $418b674ba8b1e0e7$var$load("hhss7"),
    $418b674ba8b1e0e7$var$load("Wowvf"),
    $418b674ba8b1e0e7$var$load("4Nzvy"),
    $418b674ba8b1e0e7$var$load("hJpvQ"),
    $418b674ba8b1e0e7$var$load("bIPPg"),
    $418b674ba8b1e0e7$var$load("lnKog"),
    $418b674ba8b1e0e7$var$load("h3ABO"),
    $418b674ba8b1e0e7$var$load("kC80R"),
    $418b674ba8b1e0e7$var$load("7EorR"),
    $418b674ba8b1e0e7$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("1fgXx", function(module, exports) {

let $0e8458e863771d2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0e8458e863771d2d$var$load("cANzj"),
    $0e8458e863771d2d$var$load("57vQM"),
    $0e8458e863771d2d$var$load("2YffH"),
    $0e8458e863771d2d$var$load("lqFMg"),
    $0e8458e863771d2d$var$load("1aRD3"),
    $0e8458e863771d2d$var$load("87LvA"),
    $0e8458e863771d2d$var$load("l1nJ9"),
    $0e8458e863771d2d$var$load("eBRUf"),
    $0e8458e863771d2d$var$load("9Vh0G"),
    $0e8458e863771d2d$var$load("hBIgN"),
    $0e8458e863771d2d$var$load("h4Nf7"),
    $0e8458e863771d2d$var$load("7f9Fz"),
    $0e8458e863771d2d$var$load("8YSo7"),
    $0e8458e863771d2d$var$load("g9CVe"),
    $0e8458e863771d2d$var$load("djHM5"),
    $0e8458e863771d2d$var$load("eJQji"),
    $0e8458e863771d2d$var$load("6wr18"),
    $0e8458e863771d2d$var$load("kjZZD"),
    $0e8458e863771d2d$var$load("3JSgG"),
    $0e8458e863771d2d$var$load("dRpV3"),
    $0e8458e863771d2d$var$load("ffEVr"),
    $0e8458e863771d2d$var$load("28arV"),
    $0e8458e863771d2d$var$load("jYUNl"),
    $0e8458e863771d2d$var$load("foy8I"),
    $0e8458e863771d2d$var$load("jY21r"),
    $0e8458e863771d2d$var$load("2vAWg"),
    $0e8458e863771d2d$var$load("7cABH"),
    $0e8458e863771d2d$var$load("9jjvO"),
    $0e8458e863771d2d$var$load("i8eeg"),
    $0e8458e863771d2d$var$load("iFdoJ"),
    $0e8458e863771d2d$var$load("2uVTT"),
    $0e8458e863771d2d$var$load("hhss7"),
    $0e8458e863771d2d$var$load("Wowvf"),
    $0e8458e863771d2d$var$load("4Nzvy"),
    $0e8458e863771d2d$var$load("hJpvQ"),
    $0e8458e863771d2d$var$load("bIPPg"),
    $0e8458e863771d2d$var$load("lnKog"),
    $0e8458e863771d2d$var$load("h3ABO"),
    $0e8458e863771d2d$var$load("kC80R"),
    $0e8458e863771d2d$var$load("7EorR"),
    $0e8458e863771d2d$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lk93G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lk93G", function(module, exports) {

let $f8627e0aeed3fccf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8627e0aeed3fccf$var$load("hJpvQ"),
    $f8627e0aeed3fccf$var$load("bIPPg"),
    $f8627e0aeed3fccf$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $h82at.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $1cfRh.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.a3378443.js.map
